import router from '@/router';
import { getAccount } from '@/utils/account';

// 页面操作list
const targetCodeList = [
  { code: 'receivablesReceiveList-1', name: '应收单-查询' },
  { code: 'receivablesReceiveList-2', name: '应收单-批量查询' },
  { code: 'receivablesReceiveList-3', name: '应收单-报表导出' },
  { code: 'receivablesReceiveList-4', name: '应收单-添加收款' },
  { code: 'receivablesReceiveList-5', name: '应收单-查看详情' },
  { code: 'receivablesReceiptList-1', name: '收款单-查询' },
  { code: 'receivablesReceiptList-2', name: '收款单-批量查询' },
  { code: 'receivablesReceiptList-3', name: '收款单-报表导出' },
  { code: 'receivablesReceiptList-4', name: '收款单-确认' },
  { code: 'receivablesReceiptList-5', name: '收款单-取消' },
  { code: 'receivablesReceiptList-6', name: '收款单-详情' },
  { code: 'paymentPayableList-1', name: '应付单-查询' },
  { code: 'paymentPayableList-2', name: '应付单-批量查询' },
  { code: 'paymentPayableList-3', name: '应付单-报表导出' },
  { code: 'paymentPayableList-4', name: '应付单-查看详情' },
  { code: 'paymentList-1', name: '付款单-查询' },
  { code: 'paymentList-2', name: '付款单-批量查询' },
  { code: 'paymentList-3', name: '付款单-复制摘要' },
  { code: 'paymentList-4', name: '付款单-合并付款' },
  { code: 'paymentList-5', name: '付款单-批量退款/付款' },
  { code: 'paymentList-6', name: '付款单-报表导出' },
  { code: 'paymentList-7', name: '付款单-查看详情' },
  { code: 'paymentList-8', name: '付款单-确认付款' },
  { code: 'paymentList-9', name: '付款单-线上付款/退款' },
  { code: 'paymentList-10', name: '付款单-线下付款/退款' },
  { code: 'paymentList-11', name: '付款单-取消' },
  { code: 'subAccountManageList-1', name: '分账单-查询' },
  { code: 'subAccountManageList-2', name: '分账单-批量查询' },
  { code: 'subAccountManageList-3', name: '分账单-报表导出' },
  { code: 'subAccountManageList-4', name: '分账单-查看详情' },
  { code: 'subAccountManageList-5', name: '分账单-重试' },
  { code: 'approvalPaymentApplyList-1', name: '付款审核-查询' },
  { code: 'approvalPaymentApplyList-2', name: '付款审核-批量查询' },
  { code: 'approvalPaymentApplyList-3', name: '付款审核-报表导出' },
  { code: 'approvalPaymentApplyList-4', name: '付款审核-通过/驳回' },
  { code: 'approvalPaymentApplyList-5', name: '付款审核-批量通过/驳回' },
  { code: 'approvalPaymentApplyList-6', name: '付款审核-查看详情' },
  { code: 'approvalSubAccountList-1', name: '分账审核-查询' },
  { code: 'approvalSubAccountList-2', name: '分账审核-批量查询' },
  { code: 'approvalSubAccountList-3', name: '分账审核-报表导出' },
  { code: 'approvalSubAccountList-4', name: '分账审核-查看详情' },
  { code: 'approvalSubAccountList-5', name: '分账审核-通过/驳回' },
  { code: 'cancelModifyOrderList-1', name: '取消/修改订单审核-查询' },
  { code: 'cancelModifyOrderList-2', name: '取消/修改订单审核-报表导出' },
  { code: 'cancelModifyOrderList-3', name: '取消/修改订单审核-查看详情' },
  { code: 'cancelModifyOrderList-4', name: '取消/修改订单审核-通过/驳回' },
  { code: 'cancelModifyOrderList-5', name: '取消/修改订单审核-批量通过/驳回' },
  { code: 'approvalRefundLists-1', name: '退款审核-查询' },
  { code: 'approvalRefundLists-2', name: '退款审核-报表导出' },
  { code: 'approvalRefundLists-3', name: '退款审核-查看详情' },
  { code: 'approvalRefundLists-4', name: '退款审核-通过/驳回' },
  { code: 'approvalRefundLists-5', name: '退款审核-取消' },
  { code: 'approvaSupplementList-1', name: '补款审核-查询' },
  { code: 'approvaSupplementList-2', name: '补款审核-报表导出' },
  { code: 'approvaSupplementList-3', name: '补款审核-通过' },
  { code: 'approvaSupplementList-4', name: '补款审核-驳回' },
  { code: 'approvaSupplementList-5', name: '补款审核-取消' },
  { code: 'approvaSupplementList-6', name: '补款审核-查看详情' },
  { code: 'servicerList-1', name: '服务商管理-查询' },
  { code: 'servicerList-2', name: '服务商管理-查看详情' },
  { code: 'servicerList-3', name: '服务商管理-导出' },
  { code: 'divideConfig-1', name: '运营管理-手工清分-确认提交' },
  { code: 'reverseRefundList-1', name: '退款记录-查询' },
  { code: 'reverseRefundList-2', name: '退款记录-报表导出' },
  { code: 'reverseRefundList-3', name: '退款记录-查看详情' },
  { code: 'reverseRefundList-4', name: '退款记录-确认退款' },
  { code: 'reverseRefundList-5', name: '退款记录-线上退款' },
  { code: 'reverseRefundList-6', name: '退款记录-线下退款' },
  { code: 'reverseRefundList-7', name: '退款记录-取消' },
  { code: 'reverseSupplementList-1', name: '补款记录-查询' },
  { code: 'reverseSupplementList-2', name: '补款记录-报表导出' },
  { code: 'reverseSupplementList-3', name: '补款记录-确认' },
  { code: 'reverseSupplementList-4', name: '补款记录-取消' },
  { code: 'tradeMainList-1', name: '对账主体管理-新增' },
  { code: 'tradeMainList-2', name: '对账主体管理-编辑' },
  { code: 'tradeMainList-3', name: '对账主体管理-删除' },
  { code: 'countingBill-1', name: '账单管理-收款账单-导出' },
  { code: 'countingBill-2', name: '账单管理-付款账单-导出' },
  { code: 'tradeListReceipt-1', name: '对账-收款-查询' },
  { code: 'tradeListReceipt-2', name: '对账-收款-查看明细' },
  { code: 'tradeListReceipt-3', name: '对账-收款-下载' },
  { code: 'tradeListReceipt-4', name: '对账-收款-重新获取' },
  { code: 'tradeListPayment-1', name: '对账-代付-查询' },
  { code: 'tradeListPayment-2', name: '对账-代付-查看明细' },
  { code: 'tradeListPayment-3', name: '对账-代付-下载' },
  { code: 'tradeListPayment-4', name: '对账-代付-重新获取' },
  { code: 'serviceIPList-1', name: 'IP管理-查询' },
  { code: 'serviceIPList-2', name: 'IP管理-修改' },
  { code: 'serviceIPList-3', name: 'IP管理-启用' },
  { code: 'serviceIPList-4', name: 'IP管理-停用' },

  { code: 'baibuBillQuotaList-1', name: '百布账期-城市额度管理-新增' },
  { code: 'baibuBillQuotaList-2', name: '百布账期-城市额度管理-编辑' },
  { code: 'baibuBillQuotaList-3', name: '百布账期-城市额度管理-启用' },
  { code: 'baibuBillQuotaList-4', name: '百布账期-城市额度管理-禁用' },

  { code: 'baibuBillCreditList-1', name: '百布账期-客户授信管理-查询' },
  { code: 'baibuBillCreditList-2', name: '百布账期-客户授信管理-批量查询' },
  { code: 'baibuBillCreditList-3', name: '百布账期-客户授信管理-启用' },
  { code: 'baibuBillCreditList-4', name: '百布账期-客户授信管理-禁用' },
  { code: 'baibuBillCreditList-5', name: '百布账期-客户授信管理-导出' },

  { code: 'baibuBillDisburseList-1', name: '百布账期-城市支用查询-查询' },
  { code: 'baibuBillDisburseList-2', name: '百布账期-城市支用查询-批量查询' },
  { code: 'baibuBillDisburseList-3', name: '百布账期-城市支用查询-报表导出' },

  { code: 'baibuBillBillList-1', name: '百布账期-客户账单管理-查询' },
  { code: 'baibuBillBillList-2', name: '百布账期-客户账单管理-批量查询' },
  { code: 'baibuBillBillList-3', name: '百布账期-客户账单管理-列表调账' },
  { code: 'baibuBillBillList-4', name: '百布账期-客户账单管理-下载' },
  { code: 'baibuBillBillList-5', name: '百布账期-客户账单管理-详情' },
  { code: 'baibuBillBillList-6', name: '百布账期-客户账单管理-详情调账' },
];

/**
 * 上传日志到sls
 * name 点击事件名称
 * code 点击事件Code
 * type 日志类型
 *
*/
export const sendWebSlsTrackingData = ({ name, code, type = 'click', params }) => {
  const userInfo = getAccount() || {};
  const [curTarget] = targetCodeList.filter((item) => item.code === code);
  const targetName = name || curTarget.name;
  const targetCode = code;
  const sendInfo = {
    type, // 日志类型
    targetName, // 点击事件名称
    targetCode, // 点击事件Code
    pageTitle: router?.currentRoute?.value?.meta?.title || window.location.hash, // 页面名称，若路由没存，则使用页面hash
    url: window.location.href, // 页面地址
    hash: window.location.hash, // 页面hash
    // 可自定义日志参数
    userId: userInfo.id || '', // 用户ID
    userName: userInfo.userName || '', // 用户名称
    params: params ? JSON.stringify(params) : '',
  };
  window.slsWebTracker.send(sendInfo);
};
